import { render } from "./datenSchutz.vue?vue&type=template&id=19287a9e"
import script from "./datenSchutz.vue?vue&type=script&lang=js"
export * from "./datenSchutz.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__